<template>
  <a-modal
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      :width="1300"
  >
    <template slot="title">
      选择采购品目 <span class="ml-2" style="color: red;font-size: 18px">注：原则上不允许选择一级品目（除非该一级品目无下级品目）。
    </span>
    </template>
    <div style="float: right" class="mr-4">
      <a-button type="primary" icon="swap" @click="switchingSearch" v-if="isShowSearch">
        {{ switchingSearchFlag ? '关闭搜索' : '打开搜索' }}
      </a-button>
    </div>
    <template v-if="!switchingSearchFlag">
      <a-radio-group v-model="defaultParam.fspmbm" @change="onSelectChange($event.target.value, defaultParam.level)"
                     button-style="solid" size="large"
                     style="margin-bottom: 20px">
        <a-radio-button value="A">
          货物类
        </a-radio-button>
        <a-radio-button value="B">
          工程类
        </a-radio-button>
        <a-radio-button value="C">
          服务类
        </a-radio-button>
      </a-radio-group>
      <a-row type="flex" :gutter="12">
        <a-col :span="6" v-for=" itemInfo in purchaseItem ">
          <span>{{ itemInfo.name }}</span>
          <div class="zdy_ul_box">
            <ul class="zdy_ul" v-if="itemInfo.data && itemInfo.data.length>0">
              <li :class="dataInfo.active?'active':''"
                  v-for="dataInfo in itemInfo.data ">
                <a-checkbox :checked="dataInfo.checked"
                            :disabled="dataInfo.nextLevelNumber>0 && itemInfo.level === purchaseItem[0].level"
                            @change="onCheckedChange($event.target.checked,dataInfo.fspmbm,itemInfo.level)"></a-checkbox>
                <template v-if="itemInfo.level<purchaseItem[3].level  && dataInfo.nextLevelNumber">
                  <span @click="onSelectChange(dataInfo.fspmbm,itemInfo.level)">{{ dataInfo.fspmmc }}</span>
                  <small>{{ dataInfo.nextLevelNumber }}</small>
                  <a-icon type="right"/>
                </template>
                <span v-else>{{ dataInfo.fspmmc }}</span>
              </li>
            </ul>
            <a-empty v-else/>
          </div>
        </a-col>
      </a-row>
    </template>
    <search-purchase-item ref="searchPurchaseItemRef" v-show="switchingSearchFlag && isShowSearch" :limit-num="limitNum"
                          :user-select-content="userSelectContent"
                          @syncUserSelectContent="onuSyncUserSelectContent"/>
    <p>最多允许选择<b
        style="color: red">{{ limitNum }}</b>个品目，您已选择<b
        style="color: red">{{ userSelectContent.length }}</b>个，还可以选择<b
        style="color: red">{{ limitNum - userSelectContent.length }}</b>个。
    </p>
    <div>
      已选择品目：
      <a-button-group size="small" class="ml-2 mt-2" v-for="(item) in userSelectContent">
        <a-button>{{ item.fspmmc }}</a-button>
        <a-button @click="removeMethod(item)" type="danger">
          <a-icon type="delete"></a-icon>
        </a-button>
      </a-button-group>
    </div>
  </a-modal>

</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { GetNextLevelItemList } from '@/epp/expertmain/purchaseitems/PurchaseRequest'
import { GetPurchaseItemLimitNum } from '@/epp/sysContentMange/api/sysContentMangeApi'
import SearchPurchaseItem from '@/epp/expertmain/purchaseitems/SearchPurchaseItem.vue'

export default {
  name: 'ChooseExpertPurchaseItem',
  components: {
    SearchPurchaseItem,
    PageView,
    STable
  },
  mounted () {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isShowSearch: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      userSelectContent: [],//用户勾选的内容
      confirmLoading: false,
      defaultParam: {
        fspmbm: 'A',
        level: 0
      },
      purchaseItem: [
        {
          name: '一级品目',
          level: 1,
          data: []
        },
        {
          name: '二级品目',
          level: 2,
          data: []
        },
        {
          name: '三级品目',
          level: 3,
          data: []
        },
        {
          name: '四级品目',
          level: 4,
          data: []
        },

      ],
      limitNum: 0,
      switchingSearchFlag: false,
    }
  },
  created () {
  },
  methods: {
    //数据回显
    async preView (json) {
      let that = this
      this.userSelectContent = json && [...json]
      that.defaultParam = {
        fspmbm: 'A',
        level: 0
      }
      await this.getItemData(this.defaultParam)
      //获取限制品目数量
      await this.getItemLimitNum()
      this.$nextTick(() => {
        //数据回显
        this.$refs.searchPurchaseItemRef?.syncCopyData(that.userSelectContent)
      })
    },
    //获取限制品目数量
    async getItemLimitNum () {
      try {
        let res = await GetPurchaseItemLimitNum()
        if (200 === res.code) {
          this.limitNum = res.result && Number(res.result)
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    //确认后数据传回调用方
    handleOk () {
      this.$emit('success', this.userSelectContent)
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //获取下一级品目数据
    async getItemData (queryData) {
      try {
        let res = await GetNextLevelItemList(queryData)
        if (200 === res.code) {
          //设置默认选中状态
          res.result.map(item => {
            item.checked = false
            item.active = false
          })
          this.purchaseItem[queryData.level].data = res.result
          //清除该阶级后面的数据
          for (let i = queryData.level + 1; i < this.purchaseItem.length; i++) {
            this.purchaseItem[i].data = []
          }
          //设置选中状态
          this.purchaseItem[queryData.level].data.map(item => {
            let selectedItem = this.userSelectContent.filter(item2 => item2.fspmbm === item.fspmbm)[0]
            if (selectedItem) {
              this.handleSelectState(true, selectedItem)
            }
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    //处理文字选中状态
    async onSelectChange (code, level) {
      await this.getItemData({
        fspmbm: code,
        level: level
      })
      if (level > 0) {
        this.purchaseItem[level - 1].data.map(item => {
          item.active = item.fspmbm === code
        })
      }
    },
    //处理多选框选中状态
    onCheckedChange (checked, code, level) {
      let that = this
      if (checked && this.userSelectContent.length >= this.limitNum) {
        this.$message.error(`最多允许选择${this.limitNum}个品目，您已选择${this.userSelectContent.length}个。`)
        return
      }
      this.purchaseItem[level - 1].data.map(item => {
        if (item.fspmbm === code) {
          item.checked = checked
          that.userSelectContent = checked ? [...that.userSelectContent, item] : that.userSelectContent.filter(item => item.fspmbm !== code)
          //同步copyData
          this.$refs.searchPurchaseItemRef?.syncCopyData(that.userSelectContent)
        }
      })
    },
    removeMethod (data) {
      this.userSelectContent = this.userSelectContent.filter(item => item.fspmbm !== data.fspmbm)
      //移除选中状态
      this.handleSelectState(false, data)
    },
    //处理选中状态
    handleSelectState (checked, data) {
      this.purchaseItem.map(item => {
        item.data.map(item2 => {
          if (item2.fspmbm === data.fspmbm) {
            item2.checked = checked
          }
        })
      })
    },
    //处理选中状态,设置未选中
    handleSelectState2 (data) {
      this.purchaseItem.map(item => {
        item.data.map(item2 => {
          item2.checked = item2.fspmbm === data.fspmbm
        })
      })
    },
    //切换搜索
    switchingSearch () {
      this.switchingSearchFlag = !this.switchingSearchFlag
      //重置搜索页数据
      if (this.switchingSearchFlag) {
        this.$refs.searchPurchaseItemRef?.onReSet()
      }
    },
    //同步用户选择品目
    onuSyncUserSelectContent (userSelectContent) {
      userSelectContent = userSelectContent || []
      this.userSelectContent = [...userSelectContent]
      if (userSelectContent.length === 0) {
        this.handleSelectState2()
        return
      }
      userSelectContent.forEach(item => {
        this.handleSelectState2(item)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

/deep/ .ant-empty {
  margin: 90px 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.close-span:hover {
  cursor: pointer;
}
</style>
